import React, { useState } from "react";
import styles from "./OngoingTask.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { DateInput, Dropdown } from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import TopTabComponent from "../../../../components/TopTabComponent/TopTabComponent";
import HeadingComponent from "../../../../components/HeadingComponent/HeadingComponent";
import StepsComponent from "../../../../components/StepsComponent/StepsComponent";
import MultipleCheck from "../../../../components/MultipleCheck/MultipleCheck";
import {
  SearchInput,
  SubmitButton,
  TextComponent,
  Modal,
  InputField,
} from "../../../../components";
import IconSidebar from "../IconSidebar/IconSidebar";
import CheckBox from "../../../../components/Checkbox/CheckBox";
import { ReactComponent as TabIcon } from "../../../../assets/images/tabIcon.svg";
import { ReactComponent as StarIcon } from "../../../../assets/images/startIcon.svg";
import { ReactComponent as ActionIcon } from "../../../../assets/images/actionicon.svg";
import { ReactComponent as Checkboxes } from "../../../../assets/images/Checkboxes.svg";
import { ReactComponent as UploadIcon } from "../../../../assets/images/file-add.svg";

import { Table, Tag, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { IoClose } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdEdit, MdOutlineDateRange } from "react-icons/md";
import { IoIosSave } from "react-icons/io";
import ModalLeft from "../../../../components/ModalLeft/ModalLeft";
import { ReactComponent as MinusIcon } from "../../../../assets/images/minusIcon.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/images/plusIcon.svg";
import InlinePointsComponent from "../../../../components/InlinePointsComponent/InlinePointsComponent";
import { ReactComponent as Crossiant } from "../../../../assets/images/QrCrossiant.svg";
import { IoIosArrowBack } from "react-icons/io";

const MachineUsedByOptions = [
  { id: 1, name: "John Smit" },
  { id: 2, name: "Emily Davis" },
  { id: 3, name: "Michael Brown" },
  { id: 4, name: "Sarah Johnson" },
  { id: 5, name: "Laura Thompson" },
  { id: 6, name: "James Miller" },
];

const DropDownOptions = [
  {
    value: "Order Update	",
    id: 1,
  },
  {
    value: "Inventory",
    id: 2,
  },
];

const options = [
  { id: 1, name: "Mixing", Icon: <TabIcon width={16} height={16} /> },
  { id: 2, name: "Make-Up", Icon: <TabIcon width={16} height={16} /> },
  { id: 3, name: "Proofing", Icon: <TabIcon width={16} height={16} /> },
  { id: 4, name: "Chill", Icon: <TabIcon width={16} height={16} /> },
];

const OngoingTask = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const [lot, setLot] = useState(false);
  const steps = ["Scaling", "Station Process"];
  const [selectedBtn, setselectedBtn] = useState("btn1");
  const current = Number(new URLSearchParams(search).get("step")) || 0;
  const [imagePreview, setImagePreview] = useState(null);
  const [focusedTab, setFocusedTab] = useState(options[0]);

  const [reason, setreason] = useState("");
  const [password, setPassword] = useState("");
  const [flagTaskDetailModal, setFlagTaskDetailModal] = useState(false);
  const [selectedFlag, setSelectedFlag] = useState(null);

  const [LotNo, setLotNo] = useState(null);
  const [finalize, setFinalize] = useState(false);
  const [confirmOrder, setConfirmOrder] = useState(false);
  const [printLabel, setPrintLabel] = useState(false);
  const [printLabelModal, setPrintLabelModal] = useState(false);
  const [flagTaskModal, setFlagTaskModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [reportDesc, setReportDesc] = useState("");
  const [ProofTime, setProofTime] = useState("");
  const [PiecesReady, setPiecesReady] = useState("");
  const [WasteQuantity, setWasteQuantity] = useState("");

  const [reportDrop, setReportDrop] = useState({
    value: "Order Update	",
    id: 1,
  });
  const [fields, setFields] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editLabel, setEditLabel] = useState("");
  const [addModal, setaddModal] = useState(false);
  const [FailTaskModal, setFailTaskModal] = useState(false);
  const [ProductName, setProductName] = useState(null);
  const [BatchNumber, setBatchNumber] = useState(null);

  const [Quantity, setQuantity] = useState(null);
  const [Station, setStation] = useState(null);
  const [Reason, setReason] = useState({
    value: "Burnt",
    id: 1,
  });

  const [quantity, setquantity] = useState(2);
  const [name, setname] = useState("");
  const [category, setcategory] = useState();
  const [itemId, setItemId] = useState("");

  const basicInfoData = {
    "Process Name": "Bulk Fermentation- Pre-Ferments",
    "Process Time": "30 Min",
  };
  const methodData = {
    "Machine Used": "Brick Oven",
    Parameters: "",
    Time: "2:30 Pm",
    Temperature: "25°C",
  };
  const additionalData = {
    Time: "2:30 Pm",
    Temperature: "25°C",
  };
  const instructionsData = {
    "01": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "02": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "03": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "04": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "05": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "06": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "07": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "08": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "09": "prep Cambro with canola oil, 11.3Kg max dough per container",
  };
  const finishedData = [
    {
      label: "Bake Temperature (Fahrenheit)",
      type: "Numeric",
      value: "45",
    },
    {
      label: "Time (minutes)",
      type: "Numeric",
      value: "20",
    },
  ];
  const onNext = () => {
    if (current < steps.length - 1) {
      navigate(`?step=${current + 1}`);
    }
  };

  const onPrev = () => {
    if (current > 0) {
      navigate(`?step=${current - 1}`);
    }
  };

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  const onChangeImg = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setImagePreview(previewURL);
    }
  };

  const categories = [
    {
      value: "Ingredient",
      role: "Ingredient",
      id: 1,
    },
    {
      value: "Component",
      role: "Component",
      id: 2,
    },
    {
      value: "Material",
      role: "Material",
      id: 3,
    },
  ];

  const reasons = [
    {
      value: "Burnt",

      id: 1,
    },
    {
      value: "Spoil",
      id: 2,
    },
  ];

  const columns = [
    {
      title: "Ingredients",
      dataIndex: "Ingredients",
      key: "Ingredients",
      render: (text, record) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
          {(record.ComponentName === "Pie Crust Dough" ||
            record.ComponentName === "Choux Pastry Shells" ||
            record.ComponentName === "Brownie Base" ||
            record.ComponentName === "Cookie Dough" ||
            record.Ingredients === "butter, unsalted") && (
            <div className={styles.ingredientCellIconsDiv}>
              <ActionIcon className={styles.icons} />
              <StarIcon className={styles.icons} />
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
    },
    {
      title: "Bakers%",
      key: "TotalBaker",
      dataIndex: "TotalBaker",
    },
    {
      title: "Available",
      key: "Available",
      dataIndex: "Available",
    },
    {
      title: "Lot Tracking",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },
  ];

  const onChangeCheckBox = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  const data = [
    {
      Ingredients: "Pie Crust Dough",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "Choux Pastry Shells",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "butter, unsalted",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "Pie Crust Dough",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "butter, unsalted",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "Choux Pastry Shells",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "butter, unsalted",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },

    {
      Ingredients: "Pie Crust Dough",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "butter, unsalted",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
  ];

  const finalColumns = [
    {
      title: "Parameter",
      dataIndex: "Parameter",
      key: "Parameter",
    },
    {
      title: "Expected",
      key: "Expected",
      dataIndex: "Expected",
    },
    {
      title: "Actual",
      key: "Actual",
      dataIndex: "Actual",
    },
  ];

  const finalData = [
    {
      Parameter: "Proof Time",
      Expected: "15 min",
      Actual: (
        <div>
          <InputField
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
              maxWidth: "150px",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={ProofTime}
            onChange={(e) => setProofTime(e.target.value)}
          />
        </div>
      ),
    },

    {
      Parameter: "Pieces Ready",
      Expected: "2",
      Actual: (
        <div>
          <InputField
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
              maxWidth: "150px",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={PiecesReady}
            onChange={(e) => setPiecesReady(e.target.value)}
          />
        </div>
      ),
    },
    {
      Parameter: "Waste Quantity",
      Expected: "0.81",
      Actual: (
        <div>
          <InputField
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
              maxWidth: "150px",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={WasteQuantity}
            onChange={(e) => setWasteQuantity(e.target.value)}
          />
        </div>
      ),
    },
  ];

  const [modalArr, setModalArr] = useState([
    "C#  123",
    "C#  124",
    "C#  123",
    "C#  125",
  ]);

  const addField = () => {
    const newField = {
      id: Date.now(),
      label: "New Field", // default name
      value: "",
    };
    setFields([...fields, newField]);
  };

  const removeField = (id) => {
    setFields(fields.filter((f) => f.id !== id));
  };

  const handleChange = (id, newValue) => {
    setFields(fields.map((f) => (f.id === id ? { ...f, value: newValue } : f)));
  };

  const handleEdit = (field) => {
    setEditingId(field.id);
    setEditLabel(field.label);
  };

  const saveEdit = (id) => {
    setFields(
      fields.map((f) => (f.id === id ? { ...f, label: editLabel } : f))
    );
    setEditingId(null);
    setEditLabel("");
  };

  const handleTabChange = (tab) => {
    setFocusedTab(tab);

    if (tab?.name === options[0]?.name) {
      navigate("/StaffRecipeProduction");
    } else if (tab?.name === options[1]?.name) {
      navigate("/StaffRecipeProduction");
    } else if (tab?.name === options[2]?.name) {
      navigate("/StaffRecipeProduction");
    } else if (tab?.name === options[3]?.name) {
      navigate("/StaffRecipeProduction");
    }
  };

  const FlagTaskDetList = (flag) => [
    {
      id: 1,
      label: "What kind of issue are you facing?",
      Value: "Missing Ingredient",
    },
    {
      id: 2,
      label: " Description",
      Value:
        "Water line pressure is low — can’t reach correct temp. Grain mix not soaked in time.",
    },
    {
      id: 1,
      label: "Date & Time ",
      Value: "9/2/2025 4:45 PM",
    },
    {
      id: 1,
      label: "Attach Photo",
      Value: (
        <div>
          <Crossiant />
        </div>
      ),
    },
    {
      id: 1,
      label: "Status",
      Value:
        flag?.Status === "Approved"
          ? "Approved"
          : flag?.Status === "Rejected"
          ? "Rejected"
          : flag?.Status === "Advised"
          ? "Advised | Stock has been adjusted"
          : "-",
    },
  ];

  const details = FlagTaskDetList(selectedFlag);

  console.log("selectedFlag", selectedFlag);

  const flagColumns = [
    {
      title: "Task",
      dataIndex: "Task",
      key: "Task",
    },
    {
      title: "Status",
      key: "Status",
      dataIndex: "Status",
    },
    {
      title: "Action",
      render: (_, record) => (
        <SubmitButton
          title="View"
          primary
          btnClass={styles.flagBtn}
          onClick={() => {
            setSelectedFlag(record);
            setFlagTaskDetailModal(true);
            setFlagTaskModal(false);
          }}
        />
      ),
    },
  ];

  const flagData = [
    {
      Task: "Faulty Machine",
      Status: "Approved",
      Action: <SubmitButton title={"View"} primary btnClass={styles.flagBtn} />,
    },
    {
      Task: "Spoiled Ingredients",
      Status: "Rejected",
      Action: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.flagBtn}
          // onClick={() => setLot(true)}
        />
      ),
    },
    {
      Task: "Damaged Goods",
      Status: "Advised",
      Action: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.flagBtn}
          // onClick={() => setLot(true)}
        />
      ),
    },
  ];

  return (
    <div className={styles.mainCont}>
      <div className={styles.headingDiv}>
        <div className={styles.Row}>
          <TextComponent
            backIcon={true}
            className={styles.Heading}
            text={"Choc Chip Cookie "}
          />
          <div className={styles.taskId}>
            <TextComponent text={"# 153485"} className={styles.idText} />
          </div>
        </div>
        <div className={styles.ButtonDiv}>
          <SubmitButton
            btnContainerClass={styles.btnContainer}
            btnClass={styles.btnClass}
            title={"Flag Task"}
            onClick={() => setFlagTaskModal(true)}
          />
          <SubmitButton
            btnContainerClass={styles.btnContainer}
            btnClass={styles.btnClass}
            primary
            title={"Log Waste"}
            onClick={() => setaddModal(true)}
          />
          {/* <SubmitButton
            btnContainerClass={styles.btnContainer}
            btnClass={styles.btnClass}
            secondary
            title={"Fail Task"}
            onClick={() => {
              setFailTaskModal(true);
            }}
          /> */}
        </div>
      </div>
      {/* <HeaderComponent
          heading={"Recipe Production"}
          headingStyle={styles.Heading}
          showBackIcon={true}
        >
          <div className={styles.Row}></div>
        </HeaderComponent> */}
      <div className={styles.stepsComp}>
        <StepsComponent
          steps={steps}
          currentStepIndex={current}
          onPrev={onPrev}
          onNext={onNext}
        />
      </div>
      {current === 0 && (
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      )}
      {current === 1 && (
        <div>
          <div className={styles.buttonsDiv}>
            <TextComponent
              className={styles.ProcessHeading}
              text={"Sourdough Dough Mix (MIX-SD-BASE)"}
            />
            <SubmitButton
              title={"Process 1"}
              primary={selectedBtn === "btn1" ? true : false}
              onClick={() => setselectedBtn("btn1")}
              btnContainerClass={styles.stageBtn}
              btnClass={styles.btn}
              textClass={styles.finishedBtnTxt}
            />
            <SubmitButton
              title={"Process 2"}
              primary={selectedBtn === "btn2" ? true : false}
              onClick={() => setselectedBtn("btn2")}
              btnContainerClass={styles.stageBtn}
              btnClass={styles.btn}
              textClass={styles.finishedBtnTxt}
            />

            {/* <FlagCircle
              style={{ width: "40px", cursor: "pointer", marginBottom: 14 }}
              onClick={() => {
                setFlagTaskModal(true);
              }}
            /> */}
          </div>

          <div className={styles.parentCont}>
            {selectedBtn === "btn1" && (
              <>
                <div className={styles.leftCont}>
                  <div className={styles.box}>
                    <TextComponent
                      className={styles.Heading}
                      text={"Basic Information"}
                    />
                    <div className={styles.itemsList}>
                      {Object.entries(basicInfoData).map(([label, value]) => {
                        const formattedLabel = label.replace(/_/g, " ");
                        return (
                          <div className={styles.row}>
                            <TextComponent
                              className={styles.label}
                              text={`${formattedLabel} :`}
                            />
                            <TextComponent
                              className={styles.value}
                              text={value || "-"}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className={styles.box}>
                    <TextComponent className={styles.Heading} text={"Method"} />
                    <div className={styles.row}>
                      <TextComponent
                        className={styles.label}
                        text={"Machine Used "}
                      />
                      <TextComponent
                        className={styles.value}
                        text={"Brick Oven"}
                      />
                    </div>
                    <div style={{ width: "100%", marginTop: 2 }}>
                      <TextComponent
                        className={styles.label}
                        text={"Machine Used By"}
                      />
                      <MultipleCheck
                        label={"John Smith"}
                        data={MachineUsedByOptions}
                        displayCheckBox
                        Inner_ContainerStyle={
                          styles.MultipleCheck_ContainerStyle
                        }
                        rangePickerInput={styles.rangePickerInput}
                        rangePickerText={styles.rangePickerText}
                      />
                    </div>
                  </div>

                  <div className={styles.box}>
                    <TextComponent
                      className={styles.Heading}
                      text={"Parameter"}
                    />
                    <div className={styles.itemsList}>
                      {Object.entries(additionalData).map(([label, value]) => {
                        const formattedLabel = label.replace(/_/g, " ");
                        return (
                          <div className={styles.row}>
                            <TextComponent
                              className={styles.label}
                              text={`${formattedLabel} :`}
                            />
                            <TextComponent
                              className={styles.value}
                              text={value || "-"}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className={styles.rightCont}>
                  <div className={styles.box}>
                    <TextComponent
                      className={styles.Heading}
                      text={"Instructions"}
                    />
                    <div className={styles.itemsList}>
                      {Object.entries(instructionsData).map(
                        ([label, value]) => {
                          const formattedLabel = label.replace(/_/g, " ");
                          return (
                            <div className={styles.InsCont}>
                              <div className={styles.inLineRow}>
                                <TextComponent
                                  className={styles.instructionslabel}
                                  text={`${formattedLabel} `}
                                />
                                <TextComponent
                                  className={styles.instructionsvalue}
                                  text={value || "-"}
                                />
                              </div>
                              <div>
                                <CheckBox onClick={onChange}></CheckBox>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                </div>

                <div className={styles.thirdCont}>
                  <IconSidebar />
                </div>
              </>
            )}
          </div>
          <div className={styles.parentCont}>
            {selectedBtn === "btn2" && (
              <>
                <div className={styles.parentCont2}>
                  <div className={styles.childCont}>
                    <div className={styles.leftCont}>
                      <div className={styles.box}>
                        <TextComponent
                          className={styles.Heading}
                          text={"Basic Information"}
                        />
                        <div className={styles.itemsList}>
                          {Object.entries(basicInfoData).map(
                            ([label, value]) => {
                              const formattedLabel = label.replace(/_/g, " ");
                              return (
                                <div className={styles.row}>
                                  <TextComponent
                                    className={styles.label}
                                    text={`${formattedLabel} :`}
                                  />
                                  <TextComponent
                                    className={styles.value}
                                    text={value || "-"}
                                  />
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                      <div className={styles.box}>
                        <TextComponent
                          className={styles.Heading}
                          text={"Method"}
                        />
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={"Machine Used "}
                          />
                          <TextComponent
                            className={styles.value}
                            text={"Brick Oven"}
                          />
                        </div>
                        <div style={{ marginTop: 2 }}>
                          <TextComponent
                            className={styles.label}
                            text={"Machine Used By"}
                          />
                          <MultipleCheck
                            label={"John Smit"}
                            data={MachineUsedByOptions}
                            displayCheckBox
                            rangePickerInput={styles.rangePickerInput}
                            rangePickerText={styles.rangePickerText}
                          />
                        </div>
                      </div>

                      <div className={styles.box}>
                        <TextComponent
                          className={styles.Heading}
                          text={"Parameter"}
                        />
                        <div className={styles.itemsList}>
                          {Object.entries(additionalData).map(
                            ([label, value]) => {
                              const formattedLabel = label.replace(/_/g, " ");
                              return (
                                <div className={styles.row}>
                                  <TextComponent
                                    className={styles.label}
                                    text={`${formattedLabel} :`}
                                  />
                                  <TextComponent
                                    className={styles.value}
                                    text={value || "-"}
                                  />
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                      <div className={styles.box}>
                        <TextComponent
                          className={styles.Heading}
                          text="QC Check"
                        />

                        <div className={styles.upload}>
                          <label className={styles.uploadLabel}>
                            <input
                              type="file"
                              accept="image/*"
                              className={styles.fileInput}
                              onChange={onChangeImg}
                            />
                            <UploadIcon className={styles.icon} />
                            <TextComponent
                              text={"Upload"}
                              className={styles.text}
                            />
                          </label>
                        </div>

                        {imagePreview && (
                          <div className={styles.previewContainer}>
                            <div
                              className={styles.closeIcon}
                              onClick={() => setImagePreview(null)}
                            >
                              <IoClose cursor={"pointer"} />
                            </div>
                            <img
                              src={imagePreview}
                              alt="Preview"
                              className={styles.previewImage}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={styles.rightCont}>
                      <div className={styles.box}>
                        <TextComponent
                          className={styles.Heading}
                          text={"Instructions"}
                        />
                        <div className={styles.itemsList}>
                          {Object.entries(instructionsData).map(
                            ([label, value]) => {
                              const formattedLabel = label.replace(/_/g, " ");
                              return (
                                <div className={styles.InsCont}>
                                  <div className={styles.inLineRow}>
                                    <TextComponent
                                      className={styles.instructionslabel}
                                      text={`${formattedLabel} `}
                                    />
                                    <TextComponent
                                      className={styles.instructionsvalue}
                                      text={value || "-"}
                                    />
                                  </div>
                                  <div>
                                    <CheckBox onClick={onChange}></CheckBox>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {!printLabel ? (
                      <SubmitButton
                        title={"Finalize"}
                        primary
                        onClick={() => {
                          setFinalize(true);
                        }}
                        // onClick={() => setselectedBtn("btn1")}
                        // btnContainerClass={styles.stageBtn}
                        // btnClass={styles.btn}
                        // textClass={styles.finishedBtnTxt}
                      />
                    ) : (
                      <SubmitButton
                        title={"Print Label"}
                        primary
                        onClick={() => {
                          setPrintLabelModal(true);
                        }}
                        // onClick={() => setselectedBtn("btn1")}
                        // btnContainerClass={styles.stageBtn}
                        // btnClass={styles.btn}
                        // textClass={styles.finishedBtnTxt}
                      />
                    )}
                  </div>
                </div>
                <div className={styles.thirdCont}>
                  <IconSidebar />
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* ////////////////////////// Waste  //////////////////////////////// */}

      <ModalLeft
        open={addModal}
        onCancel={() => setaddModal(false)}
        className={styles.modalCont}
        title={"Add Waste Entry"}
        buttonTitle={"save"}
        onBtnPress={() => setaddModal(false)}
        btnStyle={{ marginTop: "20px", width: "50%" }}
      >
        <div className={styles.modalContent}>
          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Item Category"} />
            <div className={styles.search_div}>
              <Dropdown
                value={category}
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                options={categories}
                onChange={(e) => setcategory(e)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Item Name"} />
            <div className={styles.search_div}>
              <SearchInput
                placeholder="Chocolate Muffin"
                rightIcon={<SearchOutlined />}
                className={styles.searchInput}
                value={name}
                onChange={(e) => setname(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Lot No"} />
            <div className={styles.search_div}>
              <InputField
                value={LotNo}
                placeholder="#230"
                onChange={(e) => setLotNo(e.target.value)}
                rightIcon={<SearchOutlined />}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Quantity"} />
            <div className={styles.itemControls}>
              <MinusIcon
                className={styles.Controls}
                onClick={() => {
                  quantity >= 1 && setquantity(quantity - 1);
                }}
              />
              <TextComponent className={styles.ControlsText} text={quantity} />
              <PlusIcon
                className={styles.Controls}
                onClick={() => setquantity(quantity + 1)}
              />
            </div>
          </div>
          <div className={styles.itemRow}>
            <TextComponent
              className={styles.itemName}
              text={"Reason for Waste"}
            />
            <div className={styles.search_div}>
              <Dropdown
                value={Reason}
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                options={reasons}
                onChange={(e) => setReason(e)}
              />
            </div>
          </div>
        </div>
      </ModalLeft>
      {/* ////////////////////////// Lot Tracking //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={lot}
        onCancel={() => {
          setLot(false);
        }}
        onClickOkButton={() => {
          setLot(false);
        }}
        className={styles.Modal}
        buttonTitle={"Confirm"}
        onBtnPress={() => setLot(false)}
      >
        <HeadingComponent text={"Heavy Cream"} className={styles.modalHead} />
        <TextComponent text={"Lot #"} className={styles.lotNo} />
        <SearchInput
          rightIcon={<SearchOutlined />}
          placeholder={"Search Lot"}
        />
        <div className={styles.modalArrDiv}>
          {modalArr?.map((item, index) => (
            <div className={styles.modalArrItem}>
              <TextComponent text={item} />
              <IoClose
                size={20}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  let arr = [...modalArr];
                  const result = arr.filter((_, i) => i !== index);
                  setModalArr(result);
                }}
              />
            </div>
          ))}
        </div>
      </Modal>

      {/* ////////////////////////// Finalize //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={finalize}
        onCancel={() => {
          setFinalize(false);
        }}
        onBtnPress={() => {
          setConfirmOrder(true);
          setFinalize(false);
        }}
        className={styles.Modal}
        buttonTitle={"Complete Task"}
      >
        <HeadingComponent text={"Finalize"} className={styles.modalHead} />
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={finalColumns}
            dataSource={finalData}
            pagination={false}
          />
        </div>
      </Modal>

      {/* ////////////////////////// Fail Task //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={FailTaskModal}
        onCancel={() => {
          setFailTaskModal(false);
        }}
        onBtnPress={() => {
          setFailTaskModal(false);
        }}
        title={"Fail Task?"}
        text={"Failing this task will result in the following:"}
        className={styles.Modal}
        twoButton
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        onClickOkButton={() => {
          setFailTaskModal(false);
        }}
        onClickCancelButton={() => {
          setFailTaskModal(false);
        }}
      >
        <div className={styles.TableDiv}>
          <InlinePointsComponent
            description={
              "All items involved in producing this product will be wasted."
            }
          />
          <InlinePointsComponent
            description={
              "The product journey will be marked as failed at this station."
            }
          />
          <InlinePointsComponent
            description={
              "A new order will need to be created to recreate the product."
            }
          />
          <InputField
            placeholder={"1**12*******"}
            innerInput={{ width: "" }}
            value={password}
            label={"Enter Supervisor Password"}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
      </Modal>

      {/* ////////////////////////// Confirm Order //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={confirmOrder}
        onCancel={() => {
          setConfirmOrder(false);
        }}
        onClickOkButton={() => {
          setConfirmOrder(false);
          setPrintLabel(true);
        }}
        twoButton
        className={styles.Modal}
        onBtnPress={() => setConfirmOrder(false)}
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        onClickCancelButton={() => setConfirmOrder(false)}
        title={"Complete Task"}
      >
        <TextComponent
          text={
            "Completing this order will finalize the task and cannot be undone. Any abnormal entries will be automatically flagged and sent to the Supervisor for review."
          }
        />
      </Modal>

      {/* ////////////////////////// PrintLabel//////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={printLabelModal}
        onCancel={() => {
          setPrintLabelModal(false);
        }}
        onClickOkButton={() => {
          setPrintLabelModal(false);
        }}
        className={styles.Modal}
        onBtnPress={() => setPrintLabelModal(false)}
        buttonTitle={"Print"}
      >
        <HeadingComponent text={"Print Label"} className={styles.modalHead} />
        <div className={styles.modalInput}>
          <InputField
            label={"Product Name "}
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={ProductName}
            onChange={(e) => setProductName(e.target.value)}
          />

          <InputField
            label={"Batch Number"}
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={BatchNumber}
            type={"number"}
            onChange={(e) => setBatchNumber(e.target.value)}
          />
        </div>

        <div className={styles.DateDiv}>
          <DateInput
            className={styles.DateInput}
            label={"Production Date"}
            placeholder={"Aug 25, 2025"}
            rightIcon={<MdOutlineDateRange />}
          />
          <DateInput
            className={styles.DateInput}
            label={"Expiry Date"}
            placeholder={"Aug 25, 2025"}
            rightIcon={<MdOutlineDateRange />}
          />
        </div>
        <div className={styles.modalInput}>
          <InputField
            label={"Station"}
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={Station}
            onChange={(e) => setStation(e.target.value)}
          />

          <InputField
            label={"Quantity"}
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={Quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </div>

        <div className={styles.addFieldCont}>
          {fields.map((field) => (
            <div key={field.id} className={styles.fieldContainer}>
              <div className={styles.fieldHeader}>
                {editingId === field.id ? (
                  <InputField
                    placeholder="Enter here…"
                    inputStyle={{
                      backgroundColor: "#F7F8F9",
                      border: "1.5px solid #E8ECF4",
                    }}
                    innerInput={{ backgroundColor: "#F7F8F9" }}
                    className={styles.editInput}
                    value={editLabel}
                    onChange={(e) => setEditLabel(e.target.value)}
                    autoFocus
                  />
                ) : (
                  <TextComponent
                    className={styles.fieldLabel}
                    text={field.label}
                  />
                )}

                <div className={styles.iconGroup}>
                  {editingId === field.id ? (
                    <IoIosSave onClick={() => saveEdit(field.id)} />
                  ) : (
                    <>
                      <RiDeleteBin6Line onClick={() => removeField(field.id)} />
                      <MdEdit onClick={() => handleEdit(field)} />
                    </>
                  )}
                </div>
              </div>

              <InputField
                placeholder="Enter here…"
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",
                }}
                innerInput={{ backgroundColor: "#F7F8F9" }}
                className={styles.inputNew}
                value={field.value}
                onChange={(e) => handleChange(field.id, e.target.value)}
              />
            </div>
          ))}

          <SubmitButton
            title="+ Add Field"
            primary
            onClick={addField}
            btnClass={styles.addFieldBtn}
          />
        </div>
      </Modal>

      {/* ////////////////////////// Flag Task //////////////////////////////// */}
      <Modal
        subClassName={styles.modalContentStyle}
        open={flagTaskModal}
        onCancel={() => {
          setFlagTaskModal(false);
        }}
        onBtnPress={() => {
          setReportModal(true);
          setFlagTaskModal(false);
        }}
        className={styles.Modal}
        buttonTitle={"Report A Problem"}
      >
        <HeadingComponent text={"Flagged Tasks"} className={styles.modalHead} />
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={flagColumns}
            dataSource={flagData}
            pagination={false}
          />
        </div>
      </Modal>

      {/* ////////////////////////FLAG TASK DETAIL  modal ///////////////// */}
      <Modal
        open={flagTaskDetailModal}
        icon={<IoIosArrowBack />}
        onIconClick={() => {
          setFlagTaskDetailModal(false);
          setFlagTaskModal(true);
        }}
        onCancel={() => {
          setFlagTaskDetailModal(false);
        }}
        onClickOkButton={() => {
          setFlagTaskDetailModal(false);
        }}
        className={styles.modalCont}
        width={"400px"}
        buttonTitle={selectedFlag?.Status === "Advised" ? "Mark as Done" : null}
        onBtnPress={() => setFlagTaskDetailModal(false)}
        btnStyle={{ marginTop: "12px" }}
      >
        <div style={{ width: "100%", marginTop: "12px" }}>
          {details.map((item) => (
            <div key={item.id}>
              <TextComponent
                className={styles.FlagTasklabel}
                text={item.label}
              />
              <div className={styles.FlagTaskvalue}>{item.Value}</div>
            </div>
          ))}
        </div>
      </Modal>

      {/* ////////////////////////// Report a Problem //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={reportModal}
        onCancel={() => {
          setReportModal(false);
        }}
        onBtnPress={() => {
          setReportModal(false);
        }}
        icon={<IoIosArrowBack />}
        onIconClick={() => {
          setReportModal(false);
          setFlagTaskModal(true);
        }}
        className={styles.Modal}
        buttonTitle={"Submit"}
      >
        <HeadingComponent
          text={"Report a Problem"}
          className={styles.modalHead}
        />
        <Dropdown
          label={"What kind of issue are you facing?"}
          placeholder={"Missing Ingredient"}
          value={reportDrop}
          options={DropDownOptions}
          onChange={(e) => setReportDrop(e)}
        />
        <InputField
          label={" Description"}
          placeholder={"Enter here…"}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          innerInput={{ backgroundColor: "#F7F8F9" }}
          className={styles.inputNew}
          value={reportDesc}
          onChange={(e) => setReportDesc(e.target.value)}
        />

        <div className={styles.box}>
          <TextComponent className={styles.Heading} text="Attach Photo" />
          <div className={styles.upload}>
            <label className={styles.uploadLabel}>
              <input
                type="file"
                accept="image/*"
                className={styles.fileInput}
                onChange={onChangeImg}
              />
              <UploadIcon className={styles.icon} />
              <span className={styles.text}>Upload</span>
            </label>
          </div>
          {imagePreview && (
            <div className={styles.previewContainer}>
              <div
                className={styles.closeIcon}
                onClick={() => setImagePreview(null)}
              >
                <IoClose cursor={"pointer"} color="white" />
              </div>
              <img
                src={imagePreview}
                alt="Preview"
                className={styles.previewImage}
              />
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default OngoingTask;
